// CompanyItem
// ***********************************************************************************************************************
import { Typography } from "@mui/material";
import * as React from "react";
import { AvatarImage } from "ui/Scripts/source/components/framework/Avatar/AvatarImage";
import { ICompanyMenuItem } from "ui/Scripts/source/models/company/companyMenuItem";

export interface ICompanyItemProp {
    classes?: boolean;
    company: ICompanyMenuItem;
}

export class CompanyItem extends React.Component<ICompanyItemProp, {}> {
    render() {
        const props = this.props;
        const company = props.company;
        if (!company) return null;
        return (
            <>
                <AvatarImage
                    size={24}
                    name={company.name}
                    image={company.logo}
                />
                <Typography sx={{ marginLeft: "8px" }}>{company.name}</Typography>
            </>
        );
    }
}